export const featuredProducts = [
  {
    id: 1,
    name: "Diseños de transportes",
    price: 44.99,
    image: "https://static.readdy.ai/image/65388bb12ee513dcffc13c09740f68f7/06f44f55d087a25eae35b05e0676bdc2.jpeg",
    category: "Educativo",
    ageRange: "1-3 años",
    rating: 4.9,
    reviews: 127,
    description: "Libro interactivo de fieltro para aprender números del 1 al 10 con actividades sensoriales",
    features: ["10 páginas de fieltro", "Números bordados", "Actividades táctiles", "Materiales seguros"]
  },
  {
    id: 2,
    name: "Aventuras en la Granja",
    price: 44.99,
    image: "https://static.readdy.ai/image/65388bb12ee513dcffc13c09740f68f7/cf9211a1eb9f8e5823336b3b8a665447.jpeg",
    category: "Cuentos",
    ageRange: "2-5 años",
    rating: 4.8,
    reviews: 89,
    description: "Cuento interactivo sobre animales de la granja con sonidos y texturas",
    features: ["12 páginas ilustradas", "Animales removibles", "Sonidos crujientes", "Historia educativa"]
  },
  {
    id: 3,
    name: "Libro de Colores Mágicos",
    price: 44.99,
    image: "https://static.readdy.ai/image/65388bb12ee513dcffc13c09740f68f7/eb8efdabec07e243d7563eaf1d8be060.jpeg",
    category: "Educativo",
    ageRange: "1-4 años",
    rating: 4.9,
    reviews: 156,
    description: "Aprende los colores básicos con actividades de clasificación y emparejamiento",
    features: ["8 colores principales", "Piezas intercambiables", "Actividades de clasificación", "Estimula creatividad"]
  },
  {
    id: 4,
    name: "Juegos",
    price: 14.99,
    image: "https://static.readdy.ai/image/65388bb12ee513dcffc13c09740f68f7/05b46978199092a5e97bf0b17463aaed.jpeg",
    category: "Fantasía",
    ageRange: "3-6 años",
    rating: 4.7,
    reviews: 73,
    description: "Cuento mágico con hadas, duendes y criaturas del bosque",
    features: ["14 páginas temáticas", "Personajes móviles", "Elementos 3D", "Historia original"]
  },
  {
    id: 5,
    name: "Cubos",
    price: 29.99,
    image: "https://static.readdy.ai/image/65388bb12ee513dcffc13c09740f68f7/cfe50e1dd45a4b2b259fc003b27f17b6.jpeg",
    category: "Educativo",
    ageRange: "1-3 años",
    rating: 4.8,
    reviews: 94,
    description: "Introduce las formas geométricas básicas de manera divertida",
    features: ["6 formas básicas", "Encajes perfectos", "Colores vibrantes", "Desarrollo motor"]
  },
  {
    id: 6,
    name: "Libro Personalizado con Nombre",
    price: 45.99,
    image: "https://static.readdy.ai/image/65388bb12ee513dcffc13c09740f68f7/2c4f9fe0c85f5e291d8f1ae903008690.jpeg",
    category: "Personalizado",
    ageRange: "2-6 años",
    rating: 5.0,
    reviews: 45,
    description: "Libro único con el nombre del niño bordado y actividades personalizadas",
    features: ["Nombre bordado", "Historia personalizada", "Colores a elegir", "Regalo único"]
  }
];

export const categories = [
  {
    id: 1,
    name: "Educativo",
    icon: "ri-graduation-cap-line",
    count: 15,
    description: "Libros para aprender jugando"
  },
  {
    id: 2,
    name: "Cuentos",
    icon: "ri-book-open-line",
    count: 12,
    description: "Historias mágicas e interactivas"
  },
  {
    id: 3,
    name: "Actividades",
    icon: "ri-puzzle-line",
    count: 8,
    description: "Juegos y actividades sensoriales"
  },
  {
    id: 4,
    name: "Personalizado",
    icon: "ri-heart-line",
    count: 6,
    description: "Libros únicos hechos a medida"
  }
];
